'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _nodeUuid = require('node-uuid');

var _ProgressBarContainer = require('../../containers/common/ProgressBarContainer');

var _ProgressBarContainer2 = _interopRequireDefault(_ProgressBarContainer);

var _translate = require('../../language/translate');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Renders the top portion of the form which persists between form pages.
 * @extends {Component}
 */
var HeaderComponent = function (_React$Component) {
  _inherits(HeaderComponent, _React$Component);

  function HeaderComponent() {
    _classCallCheck(this, HeaderComponent);

    return _possibleConstructorReturn(this, (HeaderComponent.__proto__ || Object.getPrototypeOf(HeaderComponent)).apply(this, arguments));
  }

  _createClass(HeaderComponent, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.logos.forEach(function (logo) {
        logo.key = (0, _nodeUuid.v4)();
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'ingle-form-header' },
        _react2.default.createElement(
          'div',
          { className: 'flex form-logos form-spacing' },
          this.props.logos.map(function (logo) {
            return _react2.default.createElement('img', _extends({}, logo, { key: logo.key, className: 'form-logo', alt: logo.alt }));
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'flex form-title form-spacing' },
          _react2.default.createElement(
            'h3',
            { className: 'div-title' },
            '' + this.props.title
          )
        ),
        this.props.coverageSummary && _react2.default.createElement(
          'div',
          { className: 'flex form-spacing' },
          _react2.default.createElement(
            'h4',
            null,
            _react2.default.createElement(
              'a',
              { target: '_blank', rel: 'noopener noreferrer', className: 'link-normal', href: this.props.coverageSummary },
              (0, _translate.t)('Coverage Summary')
            )
          )
        ),
        this.props.navigation.currentPage < this.props.progressBarProps.progressText.length && _react2.default.createElement(_ProgressBarContainer2.default, this.props.progressBarProps)
      );
    }
  }]);

  return HeaderComponent;
}(_react2.default.Component);

HeaderComponent.propTypes = {
  logos: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
  title: _react2.default.PropTypes.string.isRequired,
  navigation: _react2.default.PropTypes.object.isRequired,
  progressBarProps: _react2.default.PropTypes.object,
  coverageSummary: _react2.default.PropTypes.string
};
exports.default = HeaderComponent;


//////////////////
// WEBPACK FOOTER
// ./src/v2/components/common/HeaderComponent.jsx
// module id = 1665
// module chunks = 0